import { guardId } from '@/api/guardId';
import type { Organisation } from '@/api/model/Organisation';
import { apiFetch } from '@/lib/http';

export interface OrganisationNotificationData {
    id: number;
    ulid: string;
    source: string;
    notification_type: string;
    severity: string;
    message: string;
    metadata: Record<string, unknown> | null;
    entity_type: string | null;
    entity_id: number | null;
    entity_ulid: string | null;
    created_at: string;
    updated_at: string;
}

interface PaginatedNotificationsResponse {
    data: OrganisationNotificationData[];
    meta: { total: number };
}

export async function fetchOrganisationNotifications(
    organisation: Organisation,
): Promise<PaginatedNotificationsResponse> {
    guardId(organisation.public_id);

    return apiFetch<PaginatedNotificationsResponse>(`/api/organisations/${organisation.public_id}/notifications`);
}
